import { supabase } from "@/lib/supabaseClient";

export type AiDraft = {
  mode: "reply" | "followup";
  intent: string;
  text: string;
  includesLink: boolean;
  stage: string | null;
  nextAction: string;
  followupDays: number | null;
  touch: number | null;
  maxTouches: number;
};

export type AiResult = { ok: true; draft: AiDraft } | { ok: false; reason: "max_touches" | "unavailable" };

/** Pide a la IA de Vívelo que redacte la respuesta (o el seguimiento). No envía nada: la persona revisa y envía. */
export async function askAiReply(args: { prospectId: string; mode: "reply" | "followup"; firstName: string; link: string }): Promise<AiResult> {
  try {
    const { data, error } = await supabase.functions.invoke("prospect-ai-reply", {
      body: { prospect_id: args.prospectId, mode: args.mode, first_name: args.firstName, link: args.link },
    });
    if (error) return { ok: false, reason: "unavailable" };
    if (data?.error === "max_touches") return { ok: false, reason: "max_touches" };
    if (data?.error || typeof data?.text !== "string") return { ok: false, reason: "unavailable" };
    return { ok: true, draft: data as AiDraft };
  } catch {
    return { ok: false, reason: "unavailable" };
  }
}